import { render } from "./section_heading.vue?vue&type=template&id=344c3d92"
import script from "./section_heading.vue?vue&type=script&lang=js"
export * from "./section_heading.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_0d900136/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__